module.exports = __webpack_public_path__ + "static/media/rodape_relatorio.ec24fe87.png";